import React from 'react';
import { useTranslation } from 'react-i18next';

import ContractVerificationMethod from '../ContractVerificationMethod';
import ContractVerificationFieldCompiler from '../fields/ContractVerificationFieldCompiler';
import ContractVerificationFieldSources from '../fields/ContractVerificationFieldSources';

const FILE_TYPES = [ '.json' as const ];

const ContractVerificationVyperStandardInput = () => {
  const { t } = useTranslation();
  return (
    <ContractVerificationMethod title={ t('via_standard_json_input') }>
      <ContractVerificationFieldCompiler isVyper/>
      <ContractVerificationFieldSources
        fileTypes={ FILE_TYPES }
        title={ t('standard_input_json') }
        hint={ t('Upload_json_tip') }
        required
      />
    </ContractVerificationMethod>
  );
};

export default React.memo(ContractVerificationVyperStandardInput);
